import React from "react";
import {MessageWithActionAndData} from "@me8eon/sessions_messages";
import {ToolCallsAssistantMessage} from "./ToolCallsAssistantMessage";
import {BaseAssistantMessage} from "./BaseAssistantMessage";

const AssistantMessage: React.FC<MessageWithActionAndData> = (message) => {

    const {toolCalls} = message;

    if (toolCalls && toolCalls.length > 0) {
        return <ToolCallsAssistantMessage {...message} />
    }

    return <BaseAssistantMessage {...message}/>

};

export default AssistantMessage;
